import Vue from 'vue'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { messages } from 'vee-validate/dist/locale/ja.json'
import i18n from './i18n'

Object.keys(rules).forEach((rule) => {
  extend(rule, {
    ...rules[rule as keyof typeof rules], // copies rule configuration
    message: messages[rule as keyof typeof messages] // assign message
  })
})

// Override default messages
// from "web/node_modules/vee-validate/dist/locale/ja.json"

// Required check
extend('required', {
  ...rules.required,
  message: i18n.t('validation.required') as string
})

extend('len_password', {
  ...rules.min,
  message: i18n.t('err_msg.login_user.len_password') as string
})

extend('numeric', {
  ...rules.numeric,
  message: i18n.t('validation.numeric_code_rule') as string
})

// Numeric values only
extend('numeric_code_rule', {
  validate(value: string) {
    const regex = /^[0-9 ]*$/
    return regex.test(value)
  },
  message: i18n.t('validation.numeric_code_rule') as string
})

// Password Length Check
extend('kana_name_rule', {
  validate(value) {
    return /^[ -~｡-ﾟ]+$/.test(value)
  },
  message: i18n.t('validation.kana_name_rule') as string
})

// Half-width alphanumeric and symbol check
extend('half_width_alphanumeric_symbol_rule', {
  validate(value: string) {
    return /^[ -~]+$/.test(value)
  },
  message: i18n.t('validation.half_width_alphanumeric_symbol_rule') as string
})

// Half-width numeric characters only
extend('half_width_number_symbol_rule', {
  validate(value: string) {
    const isHalfWidth = /^[ -~]+$/.test(value)
    const hasNoLetters = !/[a-zA-Z]/.test(value)
    return isHalfWidth && hasNoLetters
  },
  message: i18n.t('validation.half_width_number_symbol_rule') as string
})

extend('numeric_hyphen_rule', {
  validate(value: string) {
    const regex = /^[0-9- ]+$/
    return regex.test(value)
  },
  message: i18n.t('validation.numeric_hyphen_rule') as string
})

extend('email', {
  ...rules.email,
  message: i18n.t('validation.email_rule') as string
})

// Duplicate Check within a list
extend('list_duplication_check', {
  validate(value: string, { list }: any) {
    if (!value || !list || !list.length) return true
    const duplicates = list.filter((item: string) => item === value)
    return duplicates.length <= 1
  },
  params: ['list'],
  message: i18n.t('err_msg.mail_is_duplicated') as string
})

// Prefecture Matching Check
extend('prefecture_match', {
  validate(value: string, { prefectures }: any) {
    if (!value || !prefectures || !prefectures.length) return true
    const matched = prefectures.find((p: any) => value.startsWith(p.name))
    return !!matched
  },
  params: ['prefectures'],
  message: i18n.t('validation.no_prefecture_found') as string
})

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
